import axios from 'axios';

import store from '../store/index';

function upload (formData) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/files/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }).then((response) => {
    store.dispatch('library/setUploadResults', response.data);
    store.dispatch('library/isUploadingOff');
    store.dispatch('library/loadLibrary', store.state.client.currentClient.id);
  });
}

function uploads (postData) {
  let currentClientId = store.state.client.currentClient.id;
  return axios.post('api/client/' + currentClientId + '/files/upload', postData.data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
    .then((response) => {
      store.dispatch('library/setUploadResults', response.data);
      store.dispatch('library/isUploadingOff');
      store.dispatch('library/loadLibrary', store.state.client.currentClient.id);
    });
}

export {
  upload,
  uploads
};



// WEBPACK FOOTER //
// ./src/services/FileService.js